var map = {
	"./Afgebroken-tand.png": 8937,
	"./Anders.png": 1657,
	"./Beugel-spalk.png": 5493,
	"./Implantaat.png": 628,
	"./Losgekomenbrug-kroon.png": 5353,
	"./Losse.png": 1889,
	"./Pijn.png": 8968,
	"./Prothese.png": 999,
	"./Tand.png": 2220,
	"./Tandvlees.png": 8268,
	"./Verstandskies.png": 4485,
	"./Vulling.png": 781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9328;